export class Term {
    id: number;
    termType: string;
    userType: string;
    value: string;
    createdBy: number;
}